import { apiSlice } from '../../../api/apiSlice';
import {
    SCORECARD_APPROVAL_ACTIVITY_EMPLOYEE,
    SCORECARD_EMPLOYEE_PAYOUT_COUNT,
    SCORECARD_PAYOUT_AGING,
    SCORECARD_PAYOUT_AGING_COUNT,
} from '../../../constants';

export const ScorecardPayoutAgingSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardPayoutAging: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardId, isMonthsMoreThanOne } = arg;
                return {
                    url: SCORECARD_PAYOUT_AGING,
                    params: { year, month, scorecardId, isMonthsMoreThanOne },
                };
            },
        }),
        getScorecardPayoutAgingEmployee: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardVersionId } = arg;
                return {
                    url: SCORECARD_APPROVAL_ACTIVITY_EMPLOYEE,
                    params: { year, month, scorecardVersionId },
                };
            },
        }),
        getScorecardPayoutAgingCount: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardId } = arg;
                return {
                    url: SCORECARD_PAYOUT_AGING_COUNT,
                    params: { year, month, scorecardId },
                };
            },
        }),
        getScorecardEmployeePayoutAgingCount: builder.query({
            query: (arg: any) => {
                const { year, month, scorecardId } = arg;
                return {
                    url: SCORECARD_EMPLOYEE_PAYOUT_COUNT,
                    params: { year, month, scorecardId },
                };
            },
        }),
    }),
});

export const {
    useGetScorecardPayoutAgingQuery,
    useGetScorecardPayoutAgingEmployeeQuery,
    useGetScorecardPayoutAgingCountQuery,
    useGetScorecardEmployeePayoutAgingCountQuery,
} = ScorecardPayoutAgingSlice;
